/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Dropdown, Link } from '@carbon/react';
import { observer } from 'mobx-react';

import { Tooltip } from 'primitives';
import { configuredClustersStore } from 'stores';
import { IDP_APPLICATION_CAMUNDA_DOCS_LINK } from 'App/Pages/Project/IdpApplication/IdpProject/utils/constants';

import getClustersWithDocumentHandling from './../utils/get-clusters-with-document-handling';
import * as Styled from './ClusterSelection.styled';

function ClusterSelectionSM({ cluster, setCluster }) {
  const clustersWithDocumentHandling = getClustersWithDocumentHandling(configuredClustersStore.clusters);

  return (
    clustersWithDocumentHandling?.length > 0 && (
      <Dropdown
        data-test="cluster-selection-dropdown"
        id="cluster-selection-dropdown"
        label="Select a cluster"
        titleText="Select a cluster"
        helperText={
          <Styled.HelperText>
            <span>
              Camunda recommends using a development (dev) cluster, version 8.7 or higher.
              <Link href={IDP_APPLICATION_CAMUNDA_DOCS_LINK} target="_blank" rel="noreferrer">
                AWS must be configured for the cluster
              </Link>
              &nbsp;before continuing.
            </span>
          </Styled.HelperText>
        }
        selectedItem={cluster}
        items={clustersWithDocumentHandling}
        // @ts-ignore
        itemToString={({ name, version }) => `${name} ${version ? `(${version})` : ''}`}
        itemToElement={({ name, version, disabled, disabledReason }) => (
          <Tooltip disabled={!disabled} title={disabledReason} justify="left" align="bottom">
            <Styled.ClusterTitle>{`${name} ${version ? `(${version})` : ''}`}</Styled.ClusterTitle>
          </Tooltip>
        )}
        onChange={({ selectedItem }) => setCluster(selectedItem)}
      />
    )
  );
}

export default observer(ClusterSelectionSM);
